import translationHu from "./hu/translation.json";
import translationEn from "./en/translation.json";
import translationRo from "./ro/translation.json";

export default {
  translationHu,
  translationEn,
  translationRo,
};
